export default "__VITE_ASSET__Ca6pdNdT__"